import React, { useContext, useState } from "react";
import Header from "../../components/Header";
import Title from "../../components/Title";
import '../Dashboard/dashboard.css';
import { ref, uploadBytes, getDownloadURL } from "@firebase/storage";
import { doc, updateDoc, getDoc } from "@firebase/firestore";
import { db, storage } from '../../services/firebaseConnection';
import { toast } from "react-toastify";
import { AuthContext } from "../../contexts/auth";
import { FiPlusCircle, FiUpload, FiTrash2 } from 'react-icons/fi';
import { useLocation, useNavigate } from 'react-router-dom';

export default function EditPost() {
    const { user } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();
    const post = location.state?.post || null;

    const [images, setImages] = useState([]);
    const [titulo, setTitulo] = useState(post?.titulo || '');
    const [descricao, setDescricao] = useState(post?.descricao || '');
    const [endereco, setEndereco] = useState(post?.endereco || '');
    const [previousImages, setPreviousImages] = useState(post?.images || []);

    async function handleFile(e) {
        const fileArray = Array.from(e.target.files);
        const validImages = fileArray.filter((image) =>
            image.type === 'image/jpeg' || image.type === 'image/png'
        );

        if (validImages.length !== fileArray.length) {
            toast.error("Envie imagens do tipo PNG ou JPEG");
        }

        setImages([...images, ...validImages]);
    }

    function handleRemoveImage(index) {
        setImages(images.filter((_, i) => i !== index));
    }

    function handleRemovePreviousImage(index) {
        setPreviousImages(previousImages.filter((_, i) => i !== index));
    }

    async function handleUpdate(e) {
        e.preventDefault();

        if (!user || !user.user_id) {
            toast.error("Usuário não autenticado. Por favor, faça login novamente.");
            console.error("User authentication error: user or user.user_id is undefined");
            return;
        }

        if (titulo !== '' && descricao !== '' && endereco !== '') {
            const promises = images.map(async (image) => {
                const storageRef = ref(storage, `images/${user.user_id}/${image.name}`);
                await uploadBytes(storageRef, image);
                const downloadURL = await getDownloadURL(storageRef);
                return downloadURL;
            });

            Promise.all(promises)
                .then((downloadURLs) => {
                    const updatedImages = [...previousImages, ...downloadURLs];

                    return updateDoc(doc(db, "posts", post.id), {
                        titulo: titulo,
                        descricao: descricao,
                        endereco: endereco,
                        images: updatedImages
                    });
                })
                .then(() => {
                    setTitulo('');
                    setDescricao('');
                    setEndereco('');
                    setImages([]);
                    toast.success("Post atualizado!");
                    navigate('/perfil'); 
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Erro ao atualizar o post.");
                });
        } else {
            toast.error("Preencha todos os campos!");
        }
    }

    return (
        <div>
            <Header />
            <div className="content">
                <Title name="Editar Post">
                    <FiPlusCircle size={25} />
                </Title>
                <div className="container">
                    <form className="formProfile" onSubmit={handleUpdate}>
                        <br />
                        <label>Título:</label>
                        <input
                            type="text"
                            placeholder="Digite o título"
                            value={titulo}
                            onChange={(e) => setTitulo(e.target.value)}
                        />
                        <label className="labelAvatar">
                            <br />
                            <div className="uploadContainer">
                                <FiUpload color="#000" size={25} />
                                <label>Selecione a imagem do computador</label>
                                <input style={{ display: 'none' }} type="file" accept="image/*" multiple onChange={handleFile} />
                            </div>
                            <br />
                            <div className="imagePreview">
                                {previousImages.map((image, index) => (
                                    <div key={index} className="imageContainer">
                                        <img src={image} alt={`Imagem ${index + 1}`} />
                                        <button type="button" onClick={() => handleRemovePreviousImage(index)} className="removeButton"  style={{ border: 0, backgroundColor: "#fff" }}>
                                        <FiTrash2 size={20} color="#ff0000"/>
                                        </button>
                                    </div>
                                ))}
                                {images.map((image, index) => (
                                    <div key={index} className="imageContainer">
                                        <img src={URL.createObjectURL(image)} alt={`Imagem ${index + 1}`} />
                                        <button
                                            type="button"
                                            onClick={() => handleRemoveImage(index)}
                                            className="removeButton"
                                            style={{ border: 0, backgroundColor: "#fff" }}
                                            >
                                            <FiTrash2 size={20} color="#ff0000"/>
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </label>
                        <label>Descrição:</label>
                        <textarea
                            style={{ resize: 'none', height: '150px' }}
                            type="text"
                            placeholder="Digite a descrição"
                            value={descricao}
                            className="textarea"
                            onChange={(e) => setDescricao(e.target.value)}
                        />
                        <label>Endereço:</label>
                        <input
                            type="text"
                            placeholder="Digite o endereço"
                            value={endereco}
                            onChange={(e) => setEndereco(e.target.value)}
                        />
                        <br />
                        <button type="submit" id="button">
                            Atualizar
                        </button>
                        <br />
                    </form>
                </div>
            </div>
        </div>
    );
}
